module.exports = __webpack_public_path__ + "img/113.8.63eaff48.png";